/* rb-b-categories.js — collection switching inside Option B.

   THE BRIEF: keep Option B, add the ability to change collection, and show as
   much PRODUCT as possible. That last part decides the design. The grid width
   is already fixed by the sidebar, so anything placed ABOVE the grid costs
   product rows on every collection page forever, while anything placed IN the
   sidebar column costs nothing — that column is shorter than the grid anyway.

   THREE PLACEMENTS, switch with ?cat=

     column  (default)  a Shop list in the filter panel, BELOW the filters.
                        Costs ZERO grid space. Filter is the job people came to
                        do, so it leads; Shop is the escape hatch and sits under
                        it. (It was above the filters at first — Mark moved it.)

     bar                a Shop dropdown in the results bar beside Sort. Also
                        zero vertical cost — it slots into a row that already
                        exists. Most compact, but a dropdown hides the choices
                        until opened, so it is the least discoverable.

     chips              a slim row of category chips directly above the grid.
                        The most obvious, and the only one that costs product
                        space: about 55px, permanently, on every collection.

   Categories come from the mega menu through the JSON blob in
   rb-b-loader.liquid, so the switcher can never drift from the menu, and the
   counts come from link.object.all_products_count rather than being typed in.

   Links are plain anchors — a real navigation. D2 swapped collections over AJAX
   and that is worth doing here too, but it is a separate job: it has to
   re-render the whole of <main> (five per-collection sections, not just the
   grid) and re-run this treatment afterwards. Not started. */

(function () {
  'use strict';

  if (!window.matchMedia('(min-width: 981px)').matches) return;

  var PLACEMENTS = ['column', 'bar', 'chips'];

  function placement() {
    var v = null;
    try {
      v = new URLSearchParams(window.location.search).get('cat');
      if (v) sessionStorage.setItem('rbbCat', v);
      else v = sessionStorage.getItem('rbbCat');
    } catch (e) {}
    return PLACEMENTS.indexOf(v) !== -1 ? v : 'column';
  }

  function cats() {
    var el = document.getElementById('rbb-cats');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  var DATA = cats();
  if (!DATA.length) return;

  var mode = placement();
  document.body.classList.add('rbb-cat-' + mode);

  /* ---- column: a Shop list under the filters ---- */
  function buildColumn(sidebar) {
    if (sidebar.querySelector('.rbb-cats')) return;

    var box = document.createElement('nav');
    box.className = 'rbb-cats';
    box.setAttribute('aria-label', 'Shop by category');

    var h = document.createElement('p');
    h.className = 'rbb-cats__head';
    h.textContent = 'Shop';
    box.appendChild(h);

    var ul = document.createElement('ul');
    ul.className = 'rbb-cats__list';
    DATA.forEach(function (c) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'rbb-cats__link' + (c.active ? ' is-on' : '');
      a.href = c.url;
      a.textContent = c.title;
      if (c.count != null) {
        var n = document.createElement('span');
        n.className = 'rbb-cats__n';
        n.textContent = c.count;
        a.appendChild(n);
      }
      li.appendChild(a);
      ul.appendChild(li);
    });
    box.appendChild(ul);

    // BELOW the filters: appended last, not inserted first.
    sidebar.appendChild(box);
  }

  /* ---- bar: a Shop dropdown beside Sort ---- */
  function buildBar(wrap) {
    if (wrap.querySelector('.rbb-catsel')) return;

    var holder = document.createElement('div');
    holder.className = 'rbb-catsel';

    var sel = document.createElement('select');
    sel.setAttribute('aria-label', 'Shop by category');
    DATA.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c.url;
      o.textContent = 'Shop · ' + c.title + (c.count != null ? ' (' + c.count + ')' : '');
      if (c.active) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
      if (sel.value) window.location.href = sel.value;
    });

    holder.appendChild(sel);
    var sort = wrap.querySelector('.rbb-sort');
    if (sort) wrap.insertBefore(holder, sort);
    else wrap.appendChild(holder);
  }

  /* ---- chips: a slim row above the grid ---- */
  function buildChips(bar) {
    if (document.querySelector('.rbb-catchips')) return;

    var row = document.createElement('nav');
    row.className = 'rbb-catchips';
    row.setAttribute('aria-label', 'Shop by category');
    DATA.forEach(function (c) {
      var a = document.createElement('a');
      a.className = 'rbb-catchip' + (c.active ? ' is-on' : '');
      a.href = c.url;
      a.textContent = c.title;
      if (c.count != null) {
        var n = document.createElement('span');
        n.className = 'rbb-catchip__n';
        n.textContent = c.count;
        a.appendChild(n);
      }
      row.appendChild(a);
    });
    bar.parentNode.insertBefore(row, bar);
  }

  function apply() {
    var sidebar = document.querySelector('.rbb-col .collection-sidebar');
    var bar = document.querySelector('.rbb-bar');
    var wrap = bar && (bar.querySelector('.collection__filters-active__wrapper') || bar);

    if (mode === 'column' && sidebar) buildColumn(sidebar);
    if (mode === 'bar' && wrap) buildBar(wrap);
    if (mode === 'chips' && bar) buildChips(bar);
  }

  /* The theme re-renders the section on every filter change, so re-inject
     afterwards — same reason every other file here watches for the swap. */
  function boot() {
    apply();
    var section = document.querySelector('.js-section__collection');
    if (!section || !window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(apply, 80);
    }).observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
